var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCancelFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Atom/Icons"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cancel",
    d: "M7 0C3.129 0 0 3.129 0 7C0 10.871 3.129 14 7 14C10.871 14 14 10.871 14 7C14 3.129 10.871 0 7 0ZM10.01 10.01C9.94524 10.0749 9.86832 10.1264 9.78364 10.1615C9.69896 10.1966 9.60818 10.2147 9.5165 10.2147C9.42482 10.2147 9.33404 10.1966 9.24936 10.1615C9.16468 10.1264 9.08776 10.0749 9.023 10.01L7 7.987L4.977 10.01C4.84612 10.1409 4.6686 10.2144 4.4835 10.2144C4.2984 10.2144 4.12088 10.1409 3.99 10.01C3.85912 9.87912 3.78559 9.7016 3.78559 9.5165C3.78559 9.42485 3.80364 9.3341 3.83871 9.24942C3.87378 9.16475 3.92519 9.08781 3.99 9.023L6.013 7L3.99 4.977C3.85912 4.84612 3.78559 4.6686 3.78559 4.4835C3.78559 4.2984 3.85912 4.12088 3.99 3.99C4.12088 3.85912 4.2984 3.78559 4.4835 3.78559C4.6686 3.78559 4.84612 3.85912 4.977 3.99L7 6.013L9.023 3.99C9.08781 3.92519 9.16475 3.87378 9.24942 3.83871C9.3341 3.80364 9.42485 3.78559 9.5165 3.78559C9.60815 3.78559 9.6989 3.80364 9.78358 3.83871C9.86825 3.87378 9.94519 3.92519 10.01 3.99C10.0748 4.05481 10.1262 4.13174 10.1613 4.21642C10.1964 4.30109 10.2144 4.39185 10.2144 4.4835C10.2144 4.57515 10.1964 4.6659 10.1613 4.75058C10.1262 4.83525 10.0748 4.91219 10.01 4.977L7.987 7L10.01 9.023C10.276 9.289 10.276 9.737 10.01 10.01Z",
    fill: "#D81717"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancelFilled);
export default __webpack_public_path__ + "static/media/icon-cancel-filled.e7d98399841d5d5461bc18111478b4b0.svg";
export { ForwardRef as ReactComponent };